import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ReportService } from 'src/app/services/common/report.service';
import { UserService } from 'src/app/services/common/user.service';
import { ReloadService } from 'src/app/services/core/reload.service';
import { UiService } from 'src/app/services/core/ui.service';
import { UtilsService } from 'src/app/services/core/utils.service';
import { Advert } from 'interfaces/common';

@Component({
  templateUrl: './advert-report.component.html',
  styleUrls: ['./advert-report.component.scss'],
})
export class AdvertReportComponent implements OnInit, OnDestroy {
  private advertId?: string;
  public dataForm!: FormGroup;

  // Subscriptions
  private subAddReport: Subscription = Subscription.EMPTY;
  private subRemoveSingleFile: Subscription = Subscription.EMPTY;
  private subUploadMultiImage: Subscription = Subscription.EMPTY;

  constructor(
    private fb: FormBuilder,
    private uiService: UiService,
    public userService: UserService,
    private reloadService: ReloadService,
    private utilsService: UtilsService,
    private reportService: ReportService,
    private translate: TranslateService,
    private dialogRef: MatDialogRef<AdvertReportComponent>,
    @Inject(MAT_DIALOG_DATA) public advert: Advert
  ) {}

  ngOnInit(): void {
    this.initDataForm();
    this.advertId = this.advert?.id;
  }

  private initDataForm() {
    this.dataForm = this.fb.group({
      report: this.fb.nonNullable.control('', [Validators.required]),
    });
  }

  public onSubmit() {
    if (this.dataForm?.invalid) {
      this.translate.get('SNACKBAR.WARN.REQUIRED_FIELD').subscribe(msg => {
        this.uiService.warn(msg);
      });
      return;
    } else {
      this.addReport();
    }
  }

  private addReport() {
    const mData = {
      ...this.dataForm?.value,
      ...{
        reportDate: this.utilsService.getDateWithCurrentTime(new Date()),
        advertId: this.advertId,
      },
    };
    this.subAddReport = this.reportService.addReport(mData).subscribe({
      next: () => {
        this.translate.get('SNACKBAR.SUCCESS.REPORT_SUBMIT').subscribe(msg => {
          this.uiService.success(msg);
        });
        this.reloadService.needRefreshData$();
        this.dialogRef.close();
      },
      error: error => {
        console.log(error);
      },
    });
  }

  ngOnDestroy() {
    this.subAddReport.unsubscribe();
    this.subRemoveSingleFile.unsubscribe();
    this.subUploadMultiImage.unsubscribe();
  }
}
